import React, { useContext, useEffect, useState } from "react";
import cs from "classnames";
import { StepWizardChildProps } from "react-step-wizard";
import { HEXStepperArrow } from "@icons/hexpert/HEXStepperArrow";
import { HexpertContext, HexpertState } from "../../contexts/HexPertProvider";
import './Stepper.scss';

type StepperProps = {
  steps: number;
  action: (startPosition: HexpertState["startSteps"]) => void;
  currentStateStep: HexpertState["startSteps"];
} & Partial<StepWizardChildProps>;

export const Stepper = ({
  steps,
  action,
  currentStateStep,
  currentStep, // from wizard
  nextStep, // from wizard
  previousStep, // from wizard
  goToStep,
  totalSteps,
  ...props
}: StepperProps) => {
  const [arrowClassname, setArrowClassName] = useState(null);
  const { state, dispatch } = useContext(HexpertContext);
  const hasMoreQuestions = state?.currentForm?.sections?.some(
    (section) => section?.determineFurtherQuestions
  );

  const offsetSteps =
    hasMoreQuestions && !state?.forceSteps
      ? state?.showLastQuestions
        ? 0
        : 2
      : 0;
  useEffect(() => {
    if (currentStep > 0 || state?.startSteps) {
      setArrowClassName("c-hex-stepper-arrow-show");
      if (state?.startSteps === "end") {
        // go to last step if we previously was at result
        // goToStep count from 1
        goToStep(steps - 1 - offsetSteps);
        // reset to start after we navigate to last step
        dispatch({ type: "setStartSteps", payload: "start" });
      }
    } else if (arrowClassname) {
      setArrowClassName("c-hex-stepper-arrow-hide");
      action(null);
    }
  }, [currentStep, currentStateStep]);

  return (
    <div className="c-hex-container-stepper">
      <div className={"c-hex-stepper"}>
        {currentStateStep ? (
          <>
            <div
              className={cs("c-hex-stepper-arrow", {
                [arrowClassname]: Boolean(arrowClassname),
              })}
              onClick={() => {
                if (currentStep === 1) {
                  setArrowClassName("c-hex-stepper-arrow-hide");
                  dispatch({ type: "setForceSteps", payload: null });
                  dispatch({ type: "showLastQuestions", payload: false });
                  dispatch({ type: "submitOnNext", payload: false });
                  action(null);
                }
                previousStep();
              }}
            >
              <HEXStepperArrow />
            </div>
            <div
              className={cs("c-hex-stepper-steps", {
                "c-hex-stepper-slide": currentStep > 1,
              })}
            >
              {Array.from(Array(steps - offsetSteps).keys()).map((step) => (
                <span className={"c-hex-stepper-step"} key={step}>
                  {step + 1}
                </span>
              ))}
              <span
                className={"c-hex-stepper-currentstep"}
                style={{
                  left: (currentStep / (steps - offsetSteps)) * 100 - 1 + "%",
                }}
              />
            </div>
          </>
        ) : null}
      </div>
    </div>
  );
};
